import { IApplicationState } from '../../../../types/types';
import { ECommentAddMode } from '../../../../types/rest/IUserMeta';
import { getAuthUser } from './getAuthUser';

const DEFAULT_COMMENT_ADD_MODE = ECommentAddMode.CTRL_ENTER;

export const getAuthUserCommentAddMode = (
    state: IApplicationState
): ECommentAddMode => {
    const user = getAuthUser(state);
    return user.meta && user.meta.commentAddMode || DEFAULT_COMMENT_ADD_MODE;
};
